import HomeIcon from "@icons/home-icon.svg";
import TextFileIcon from "@icons/text-file.svg";
import ClockIcon from "@icons/Clock.svg";
import NotificationIcon from "@icons/notification.svg";
import LogOutIcon from "@icons/logout.svg";
import UserIcon from "@icons/user.svg";
import Settings from "@icons/Settings.svg";

export const administrationItems = {
  title: "Administration",
  options: [
    {
      menuLabel: "Locations",
      icon: HomeIcon,
    },
  ],
};

export const navigationItems = {
  title: "Main Navigation",
  options: [
    {
      menuLabel: "Home",
      icon: HomeIcon,
    },
    {
      menuLabel: "Check Information",
      icon: TextFileIcon,
    },
    {
      menuLabel: "Historical Reports",
      icon: ClockIcon,
    },
    {
      menuLabel: "Notifications",
      icon: NotificationIcon,
    },
  ],
};

export const settingsItems = {
  title: "Account",
  options: [
    {
      menuLabel: "Profile",
      icon: UserIcon,
    },
    {
      menuLabel: "Settings",
      icon: Settings,
    },
    {
      menuLabel: "Log Out",
      icon: LogOutIcon,
    },
  ],
};
